<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن شماره</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="12">
                                    <CTextarea
                                    v-model="form.number.val" :description="form.number.inv"
                                    label="شماره" dir="ltr" rows="3" 
                                    @keyup.enter="access=false" />
                                    <small>شماره‌ها با ویرگول انگلیسی از هم جدا می‌شوند.</small>
                                </CCol>
                            </CRow>  
                            <br>
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>درگاه</label>
                                    <model-select :options="gateways" v-model="form.sms_gateway_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.sms_gateway_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>تعرفه</label>
                                    <model-select :options="fees" v-model="form.operators_fee_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.operators_fee_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.url_check.val"
                                        :description="form.url_check.inv"
                                        label="URL check"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.url_check.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_confirme.val"
                                        :description="form.is_confirme.inv"
                                        label="is confirme"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_confirme.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.delivery_base.val"
                                        :description="form.delivery_base.inv"
                                        label="delivery base"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.delivery_base.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.check_blacklist.val"
                                        :description="form.check_blacklist.inv"
                                        label="check blacklist"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.check_blacklist.val=$event.target.value"
                                    />
                                </CCol> 
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_service.val"
                                        :description="form.is_service.inv"
                                        label="is service"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_service.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_global.val"
                                        :description="form.is_global.inv"
                                        label="is global"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_global.val=$event.target.value"
                                    />
                                </CCol> 
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.can_receive.val"
                                        :description="form.can_receive.inv"
                                        label="can receive"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.can_receive.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <label>لینک دریافت</label>
                                    <model-select :options="links" v-model="form.url_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.url_id.inv}}</small>
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="6" v-if="form.user_id.val != ''">
                <CCard>
                    <CCardHeader>
                        <strong>شماره‌های کاربر انتخاب شده</strong>
                    </CCardHeader>
                    <CCardBody>
                    <CDataTable
                        columnFilter
                        hover
                        striped
                        :items="user_numbers"
                        :fields="[
                            { key: 'id', label: 'شناسه' },
                            { key: 'number', label: 'شماره' },
                            { key: 'operators_fee_name', label: 'نام تعرفه' },
                            { key: 'sms_gateway_name', label: 'نام درگاه' },
                        ]"
                        :items-per-page="10"
                        :active-page="active_page"
                        :pagination="{ doubleArrows: false, align: 'center'}"
                        :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
                    />
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol sm="6" v-if="form.operators_fee_id.val != ''">
                <CCard>
                    <CCardHeader>
                        <strong>جزییات تعرفه انتخاب شده</strong>
                    </CCardHeader>
                    <CCardBody>
                    <CDataTable
                        columnFilter
                        hover
                        striped
                        :items="fee_detail"
                        :fields="[
                            { key: 'id', label: 'شناسه' },
                            { key: 'mobile_operator_name', label: 'اپراتور' },
                            { key: 'fee_en', label: 'تعرفه انگلیسی (ریال)' },
                            { key: 'fee_fa', label: 'تعرفه فارسی (ریال)' },
                        ]"
                        :items-per-page="10"
                        :active-page="active_page"
                        :pagination="{ doubleArrows: false, align: 'center'}"
                        :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
                    />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: { val: '', inv: '', v: { req: true, max: 8 } },
                number: { val: '', inv: '', v: { req: true, max: 1024 } },
                sms_gateway_id: { val: '', inv: '', v: { req: true, max: 4 } },
                is_active: { val: '', inv: '', v: { req: true, max: 8 } },
                operators_fee_id: { val: '', inv: '', v: { req: true, max: 8 } },
                url_check: { val: '', inv: '', v: { req: true, max: 8 } },
                is_confirme: { val: '', inv: '', v: { req: true, max: 8 } },
                delivery_base: { val: '', inv: '', v: { req: true, max: 8 } },
                check_blacklist: { val: '', inv: '', v: { req: true, max: 8 } },
                is_service: { val: '', inv: '', v: { req: true, max: 8 } },
                is_global: { val: '', inv: '', v: { req: true, max: 8 } },
                can_receive: { val: '', inv: '', v: { req: true, max: 8 } },
                url_id: { val: '', inv: '', v: { req: true, max: 512 } },
            },
            disable: false,
            users: [],
            gateways: [],
            fees: [],
            user_numbers: [],
            fee_detail: [],
            active_page: 1,
            links: [],
            access: true,
        }
    },
    watch: {
        'form.user_id.val': {
            handler(){
                this.get_numbers();
                this.get_links();
                if(this.form.operators_fee_id.val != ''){
                    this.form.operators_fee_id.val = '';
                }
                if(this.form.sms_gateway_id.val != ''){
                    this.form.sms_gateway_id.val = '';
                }
            }
        },
        'form.operators_fee_id.val': {
            handler(){
                this.get_fee_detail();
            }
        },
        'form.sms_gateway_id.val':{
            handler(){
                if(this.form.user_id.val != ''){
                    this.fill_fee();
                }
            }
        }
    },
    mounted(){
        this.get_users();
        this.get_gateways();
        this.get_fees();
    },
    methods: {
        get_fees(){
            this.axios.get('operators_fee/')
            .then(res => {
                res.data.map(val => {
                    this.fees.push({value: val.id, text: val.name});
                });
            })
        },
        get_gateways(){
            this.axios.get('sms_gateways/')
            .then(res => {
                res.data.map(val => {
                    this.gateways.push({value: val.id, text: val.name});
                });
            })
        },
        get_users(){
            this.axios.get('users/?type=add_user_nums')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        submit(){
            if(this.access){
                if(this.disable == false){
                    let tmp = this.form.number.val.split(',');
                    let numbers = [];
                    let i = 0;
                    tmp.map(val => {
                        i++;
                        numbers.push(parseInt(val));
                    });
                    for(let j=0; j<i; j++){
                        const data = new FormData();
                        for (const key in this.form){
                            if(key == 'number'){
                                data.set(key, numbers[j]);
                            } else if(key != 'url_id'){
                                data.set(key, this.form[key].val);
                            } 
                        }
                        this.axios.post('user_nums/', data)
                            .then(res => {
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    text: 'افزودن با موفقیت انجام شد.'
                                });
                                if(this.form.user_id.val != ''){
                                    const data = new FormData();
                                    data.set('url_id', this.form.user_id.val);
                                    data.set('user_num_id', res.data.id);
                                    this.axios.post('/url_to_nums/', data)
                                }
                                for (const key in this.form){
                                    this.form[key].val = '';
                                }
                            })
                            .catch(() => {
                                this.$notify({
                                    group: 'foo',
                                    type: 'error',
                                    text: 'خطا! لطفا مجددا تلاش کنید.'
                                });
                            })
                    }   
                }
            }
            this.access = true;
        },
        get_numbers(){
            this.axios.get('user_nums/'
                + '?user_id=' + this.form.user_id.val
                + '&operators_fee=1'
                + '&gateway_info=1')
                .then(res => {
                    res.data.map(val => {
                        val.operators_fee_name = val.operators_fee.name;
                        val.sms_gateway_name = val.gateway_info.name;
                    })
                    this.user_numbers = res.data;
                })
        },
        get_links(){
            this.axios.get('user_urls/'
                + '?user_id=' + this.form.user_id.val)
                .then(res => {
                    res.data.map(val => {
                        this.links.push({value: val.id, text: val.url_link});
                    })
                })
        },
        get_fee_detail(){
            this.axios.get('operators_fee_info/'
                + '?operator_fee_id=' + this.form.operators_fee_id.val
                + '&mobile_operator=1')
                .then(res => {
                    res.data.map(val => {
                        val.mobile_operator_name = val.mobile_operator.name;
                    });
                    this.fee_detail = res.data;
                })
        },
        fill_fee(){
            this.axios.get('user_nums/'
                +'?user_id=' + this.form.user_id.val
                + '&sms_gateway_id=' + this.form.sms_gateway_id.val)
                .then(res => {
                    if(res.data.length == 0){
                        this.form.operators_fee_id.val = '';
                    } else {
                        this.form.operators_fee_id.val = res.data[0].operators_fee_id;
                    }
                })
        }
    },
    beforeCreate() {
        if (this.$store.state.perms.can_add_all_users_nums == false
            && this.$store.state.perms.can_add_same_group_users_nums == false
            && this.$store.state.perms.can_add_user_nums == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
